import React, { useContext, useRef, useState } from "react";
import { useDrag, useDrop } from "react-dnd";
import {
  MdClose,
  MdDelete,
  MdEdit,
  MdMail,
  MdPhone,
  MdVisibility,
} from "react-icons/md";
import { toast } from "react-toastify";
import api from "../../services/api";
import BoardContext from "../Board/context";
import { Container, InputTel, Label, ModalConfirm, ViewInput } from "./styles";
import { format } from "date-fns";
import "dayjs/locale/pt-br";
import { FaWhatsapp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Input } from "antd";

const { TextArea } = Input;

export default function Card({ data, userId, grid, lists, index, listIndex }) {
  const ref = useRef();

  const navigate = useNavigate();

  const { move, edit } = useContext(BoardContext);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_number, setPhone_number] = useState("");
  const [employees, setEmployees] = useState("");
  const [necessity, setNecessity] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [location, setLocation] = useState("");
  const [observation, setObservation] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);

  const [{ isDragging }, dragRef] = useDrag({
    item: { type: "CARD", index, listIndex },
    canDrag: isOpenDelete || isOpenEdit || isOpen ? false : true,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, dropRef] = useDrop({
    accept: "CARD",
    canDrag: false,
    drop(item, monitor) {
      const draggedListIndex = item.listIndex;
      const targetListIndex = listIndex;

      const draggedIndex = item.index;
      const targetIndex = listIndex;

      if (draggedListIndex === targetListIndex) {
        return;
      }

      move(
        draggedListIndex,
        targetListIndex,
        lists[draggedListIndex].leads[draggedIndex].id,
      );

      item.index = targetIndex;
      item.listIndex = targetListIndex;
    },
  });

  dragRef(dropRef(ref));

  function IsEmail(field) {
    const regx = /^[a-z0-9.]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i;
    return regx.test(field);
  }

  function IsPhone(field) {
    if (field.length >= 10) {
      return true;
    } else {
      return false;
    }
  }

  async function editLead() {
    if (!name) {
      toast.warn("Preencha nome para editar");
    } else {
      if (email) {
        if (!IsEmail(email)) {
          toast.warn("Email inserido é inválido");
          return;
        }
      }
      if (phone_number) {
        if (!IsPhone(phone_number)) {
          toast.warn("Telefone inserido é inválido");
          return;
        }
      }
      await api
        .put(`/lead/${data.id}`, {
          name: name,
          email: email.toLowerCase().replace(/ /g, ""),
          observation: observation,
          phone_number: phone_number,
          employees: employees,
          necessity: necessity,
          cnpj: cnpj,
          location: location,
        })
        .then((response) => {
          toast.success("Lead editado com sucesso");
          let listC = lists;
          listC[listIndex].leads[index] = {
            ...response.data,
            historical: listC[listIndex].leads[index].historical || [],
          };
          edit(listC);
          setIsOpenEdit(false);
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        });
    }
  }

  async function resetLead() {
    await api
      .put(`/reset-lead/${data.id}`)
      .then((response) => {
        toast.success("Lead reiniciado com sucesso");
        let listC = lists;
        listC[1].leads.push({
          ...response.data,
          historical: listC[listIndex].leads[index].historical || [],
        });
        listC[listIndex].leads = listC[listIndex].leads.filter(
          (item) => item.id != data.id,
        );
        edit(listC);
        setIsOpenEdit(false);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function deleteLead() {
    await api
      .delete(`/lead/${data.id}`)
      .then((response) => {
        toast.success("Lead deletado com sucesso");
        setIsOpen(false);
        let listC = lists;
        listC[listIndex].leads = listC[listIndex].leads.filter((item) => {
          return item.id != data.id;
        });
        edit(listC);
        setIsOpenDelete(false);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  return (
    <Container ref={ref} isDragging={isDragging}>
      <div className="headerCard">
        <Label key={data.id} color={"#AAC8AA"} />
        <p>{data.tag}</p>
      </div>
      <p style={{ width: "calc(100% - 50px)" }}>{data.name}</p>

      {data.email && (
        <p style={{ fontSize: 12, color: "#0009" }}>Email: {data.email}</p>
      )}
      {data.phone_number && (
        <p style={{ fontSize: 12, color: "#0009" }}>
          Telefone: {data.phone_number}
        </p>
      )}
      {data.observation && (
        <p style={{ fontSize: 12, color: "#0009" }}>
          Observação: {data.observation}
        </p>
      )}
      <p>
        {(data.value || 0).toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
        })}
      </p>
      {listIndex == 3 && !data.contract_id && !userId && (
        <button
          style={{
            margin: "5px 5px 2px 0",
            padding: "5px 10px",
            fontSize: 12,
            borderRadius: 15,
            background: "#f2760a",
            color: "#FFF",
          }}
          onClick={() => {
            navigate(`/new-contract?lead=${data.id}&crm=true`);
          }}
        >
          Enviar Proposta
        </button>
      )}
      {listIndex >= 3 && data.contract_id && !userId && (
        <button
          style={{
            margin: "5px 5px 2px 0",
            padding: "5px 10px",
            fontSize: 12,
            borderRadius: 15,
            background: "#f2760a",
            color: "#FFF",
          }}
          onClick={() => {
            navigate(`/contract/${data.contract_id}`);
          }}
        >
          Ver Proposta
        </button>
      )}
      {(listIndex == 4 || listIndex == 5) && data.contract_id && !userId && (
        <button
          style={{
            margin: "5px 5px 2px 0",
            padding: "5px 10px",
            fontSize: 12,
            borderRadius: 15,
            background: "#f2760a",
            color: "#FFF",
          }}
          onClick={() => {
            navigate(`/edit-contract/${data.contract_id}`);
          }}
        >
          Editar Proposta
        </button>
      )}
      {listIndex == 7 && (
        <button
          style={{
            margin: "5px 5px 2px 0",
            padding: "5px 10px",
            fontSize: 12,
            borderRadius: 15,
            background: "#f2760a",
            color: "#FFF",
          }}
          onClick={() => {
            navigate(`/solicitacao`);
          }}
        >
          Solicitar OS
        </button>
      )}
      {listIndex == 6 && (
        <button
          style={{
            margin: "5px 5px 2px 0",
            padding: "5px 10px",
            fontSize: 12,
            borderRadius: 15,
            background: "#f2760a",
            color: "#FFF",
          }}
          onClick={() => {
            resetLead();
          }}
        >
          Reiniciar Processo
        </button>
      )}
      {listIndex == 7 && (
        <button
          style={{
            margin: "5px 5px 2px 0",
            padding: "5px 10px",
            fontSize: 12,
            borderRadius: 15,
            background: "#f2760a",
            color: "#FFF",
          }}
          onClick={() => {
            navigate(`/companies`);
          }}
        >
          Formulário de Levantamento
        </button>
      )}
      <div
        style={{
          flex: 1,
          marginTop: 10,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex" }}>
            {data.phone_number && (
              <FaWhatsapp
                onClick={() => {
                  window.open(
                    `https://api.whatsapp.com/send/?phone=55${data.phone_number}`,
                  );
                }}
                size={18}
                color={"#0c0"}
                style={{ margin: "0 4px 0 0", cursor: "pointer" }}
              />
            )}
            {data.phone_number && (
              <MdPhone
                onClick={() => {
                  window.open(`tel:${data.phone_number}`);
                }}
                size={18}
                style={{ margin: "0 4px", cursor: "pointer" }}
              />
            )}
            {data.email && (
              <MdMail
                onClick={() => {
                  window.open(`mailto${data.email}`);
                }}
                size={20}
                color={"#FAB833"}
                style={{ margin: "0 4px", cursor: "pointer" }}
              />
            )}
          </div>
          <div style={{ display: "flex" }}>
            <MdVisibility
              onClick={() => {
                setIsOpen(true);
              }}
              size={20}
              style={{ margin: "0 4px", cursor: "pointer" }}
            />
            {!userId && (
              <>
                <MdEdit
                  onClick={() => {
                    setIsOpenEdit(true);
                    setName(data.name);
                    setEmail(data.email);
                    setObservation(data.observation);
                    setEmployees(data.employees);
                    setCnpj(data.cnpj);
                    setNecessity(data.necessity);
                    setLocation(data.location);
                    setPhone_number(data.phone_number);
                  }}
                  size={18}
                  style={{ margin: "0 4px", cursor: "pointer" }}
                />
                {data.tag == "Cadastrado" && (
                  <MdDelete
                    onClick={() => {
                      setIsOpenDelete(true);
                    }}
                    size={18}
                    style={{ margin: "0 0 4px 0", cursor: "pointer" }}
                  />
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <ModalConfirm open={isOpenDelete}>
        <div className="content">
          <div className="content-header">
            <p>Deseja deletar o lead?</p>
            <button type="button" className="close-button">
              <MdClose
                size={20}
                color="#3a3a3a"
                onClick={() => setIsOpenDelete(false)}
              />
            </button>
          </div>
          <footer className="content-footer">
            <span onClick={() => setIsOpenDelete(false)}>Cancelar</span>
            <button
              style={{ background: "#c33", cursor: "pointer" }}
              onClick={async () => {
                deleteLead();
              }}
            >
              Confirmar
            </button>
          </footer>
        </div>
      </ModalConfirm>

      <ModalConfirm open={isOpenEdit}>
        <div className="content">
          <div className="content-header">
            <p>Editando lead</p>
            <button type="button" className="close-button">
              <MdClose
                size={20}
                color="#3a3a3a"
                onClick={() => setIsOpenEdit(false)}
              />
            </button>
          </div>
          <ViewInput>
            <p>Nome</p>
            <Input
              placeholder="nome"
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
          </ViewInput>
          <ViewInput>
            <p>Email</p>
            <Input
              placeholder="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </ViewInput>
          <ViewInput>
            <p>Telefone</p>
            <InputTel
              mask="(99) 99999-9999"
              maskChar=""
              noSpaceBetweenChars={true}
              value={phone_number}
              placeholder={"telefone"}
              style={{}}
              onChange={(text) => {
                setPhone_number(text.target.value.replace(/[^0-9]/g, ""));
              }}
            />
          </ViewInput>
          <ViewInput>
            <p>Necessidade</p>
            <Input
              placeholder="necessidade"
              value={necessity}
              onChange={(event) => setNecessity(event.target.value)}
            />
          </ViewInput>
          <ViewInput>
            <p>Funcionários</p>
            <Input
              placeholder="funcionários"
              value={employees}
              onChange={(event) => setEmployees(event.target.value)}
            />
          </ViewInput>
          <ViewInput>
            <p>CNPJ</p>
            <Input
              placeholder="cnpj"
              value={cnpj}
              onChange={(event) => setCnpj(event.target.value)}
            />
          </ViewInput>
          <ViewInput>
            <p>Localização</p>
            <Input
              placeholder="localização"
              value={location}
              onChange={(event) => setLocation(event.target.value)}
            />
          </ViewInput>
          <ViewInput>
            <p>Observação</p>
            <TextArea
              style={{ minHeight: 60 }}
              placeholder="observação"
              value={observation}
              onChange={(event) => setObservation(event.target.value)}
            />
          </ViewInput>
          <footer className="content-footer">
            <span onClick={() => setIsOpenEdit(false)}>Cancelar</span>
            <button
              style={{ background: "#f2760a", cursor: "pointer" }}
              onClick={async () => {
                editLead();
              }}
            >
              Editar
            </button>
          </footer>
        </div>
      </ModalConfirm>

      <ModalConfirm open={isOpen}>
        <div className="content" style={{ padding: 0 }}>
          <Container style={{ borderTopWidth: 30, margin: 0 }}>
            <div
              className="headerCard"
              style={{ minWidth: "100%", maxWidth: "100%", height: 30 }}
            >
              <Label key={data.id} color={"#f2760a"} />
              <p>{grid.name}</p>
            </div>
            <MdClose
              style={{ position: "absolute", top: 5, right: 10 }}
              size={20}
              color="#3a3a3a"
              onClick={() => setIsOpen(false)}
            />
            <p style={{ width: "calc(100% - 50px)", marginTop: 10 }}>
              {data.name}
            </p>
            {data.email && (
              <p style={{ fontSize: 12, color: "#0009" }}>
                Email: {data.email}
              </p>
            )}
            {data.phone_number && (
              <p style={{ fontSize: 12, color: "#0009" }}>
                Telefone: {data.phone_number}
              </p>
            )}
            {data.necessity && (
              <p style={{ fontSize: 12, color: "#0009" }}>
                Necessidade: {data.necessity}
              </p>
            )}
            {data.employees && (
              <p style={{ fontSize: 12, color: "#0009" }}>
                Funcionarios: {data.employees}
              </p>
            )}
            {data.cnpj && (
              <p style={{ fontSize: 12, color: "#0009" }}>CNPJ: {data.cnpj}</p>
            )}
            {data.location && (
              <p style={{ fontSize: 12, color: "#0009" }}>
                Localização: {data.location}
              </p>
            )}
            {data.observation && (
              <p style={{ fontSize: 12, color: "#0009", width: "85%" }}>
                Observação: {data.observation}
              </p>
            )}
            <p style={{ marginBottom: 5 }}>
              {(data.value || 0).toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })}
            </p>
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
              }}
              onClick={() => {}}
            >
              <div style={{ display: "flex" }}>
                {data.phone_number && (
                  <FaWhatsapp
                    onClick={() => {
                      window.open(
                        `https://api.whatsapp.com/send/?phone=55${data.phone_number}`,
                      );
                    }}
                    size={18}
                    color={"#0c0"}
                    style={{ margin: "0 4px 0 0", cursor: "pointer" }}
                  />
                )}

                {data.phone_number && (
                  <MdPhone
                    onClick={() => {
                      window.open(`tel:${data.phone_number}`);
                    }}
                    size={18}
                    style={{ margin: "0 4px", cursor: "pointer" }}
                  />
                )}

                {data.email && (
                  <MdMail
                    onClick={() => {
                      window.open(`mailto${data.email}`);
                    }}
                    size={20}
                    color={"#FAB833"}
                    style={{ margin: "0 4px", cursor: "pointer" }}
                  />
                )}
              </div>
            </div>
            {!!data.historical.length && (
              <p style={{ margin: "4px 0", fontSize: 13 }}>Historico</p>
            )}
            <div
              className="scrollStyle"
              style={{ maxHeight: 200, overflowY: "scroll" }}
            >
              {data.historical.map((item) => {
                return (
                  <p style={{ fontSize: 12, color: "#555", fontWeight: 500 }}>
                    {format(new Date(item.create_at), "dd/MM/yyyy HH:mm")}:{" "}
                    {item.name}
                  </p>
                );
              })}
            </div>
          </Container>
        </div>
      </ModalConfirm>
    </Container>
  );
}
